import { createAsyncThunk } from "@reduxjs/toolkit";
import { reactToast } from "../../../helper";
import { fetchStudentUnreviewedSessions } from "../../../services/student";

export const getUnReviewedSessions = createAsyncThunk(
  "data/getUnReviewedSessions",
  async ({ studentId }) => {
    try {
      const { status, data } = await fetchStudentUnreviewedSessions(studentId);

      if (status === 200) {
        if (data?.data?.length) {
          return data?.data;
        } else {
          return [];
        }
      } else {
        reactToast("error", data?.message);
      }
    } catch (error) {
      console.log(error);
    }
  }
);
